var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureFileAddContactInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_356_1",
    "data-name": "Component 356 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4987",
    "data-name": "Group 4987",
    transform: "translate(-800 -236)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(800 236)",
    fill: "#deebfe"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Add_user",
    "data-name": "Add user",
    transform: "translate(5.025 6.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    d: "M9.551,12.7V11.582A2.244,2.244,0,0,0,7.309,9.34H2.842A2.244,2.244,0,0,0,.6,11.582V12.7",
    transform: "translate(0 -2.031)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    cx: 2.242,
    cy: 2.242,
    r: 2.242,
    transform: "translate(2.834 0.6)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    d: "M10.79.69a2.239,2.239,0,0,1,0,4.337",
    transform: "translate(-2.368 -0.021)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M14.708,6.71V9.827m1.558-1.558H13.15",
    transform: "translate(-2.916 -1.42)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureFileAddContactInactive);
export default __webpack_public_path__ + "static/media/secure-file-add-contact-inactive.bf4c7f510870e537879f9e0e46c19d48.svg";
export { ForwardRef as ReactComponent };